import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';

import { FdkIllustrationComponent } from '../illustration/illustration.component';
import { FdkIllustrationName } from '../illustration/illustration.types';

@Component({
  selector: 'fdk-state-view',
  imports: [FdkIllustrationComponent],
  templateUrl: './state-view.component.html',
  styleUrl: './state-view.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FdkStateViewComponent {
  @Input({ required: true }) illustration!: FdkIllustrationName;
  @Input({ required: true }) title!: string;
  @Input({ required: true }) subtitle!: string;
}
